import { SharedAngular } from '@Client/@types/sharedAngular';
import { getInjector } from '@Shared.Angular/flowingly.helper/serviceInjector';

/**
 * Hook to get angularJs service via injector
 * @typedef T - type of the service
 * @param name
 * @returns T - the angularJs service
 */
export const useService = <T>(name: RunnerServiceName): T =>
  getInjector().get(name) as T;

type ServiceTypeMap = {
  APP_CONFIG: SharedAngular.APP_CONFIG;
  permissionsService: SharedAngular.PermissionsService;
  flowsUtilityService: SharedAngular.FlowsUtilityService;
  browserUtilsService: SharedAngular.BrowserUtilsService;
  tempModelerUrlService: SharedAngular.TempModelerUrlService;
  sessionService: SharedAngular.SessionService;
  $state: angular.ui.IStateService;
  flowListManager: FlowListManager;
  runnerCategoryNavigationService: RunnerCategoryNavigationService;
  appInsightsService: SharedAngular.AppInsightsService;
  pubsubService: SharedAngular.PubSubService;
  [key: string]: unknown;
};

export const getService = <K extends RunnerServiceName>(
  name: K
): ServiceTypeMap[K] => getInjector().get(name) as ServiceTypeMap[K];
